import { JoonUIColor, SPACING } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

import MobileNavLink from "./MobileNavLink"
import useIsCoachingAvailable from "../../hooks/useIsCoachingAvailable"
import useCareTeam from "../../pages/care/useCareTeam"
import useCoachStore from "../../pages/coach/useCoachStore"
import CareIcon from "../icons/CareIcon"
import FamilyIcon from "../icons/FamilyIcon"
import MeIcon from "../icons/MeIcon"
import QuestsIcon from "../icons/QuestsIcon"
import RewardsIcon from "../icons/RewardsIcon"

const MobileNav = () => {
  const { isFocused: userIsTypingMessageToCoach } = useCoachStore()
  const location = useLocation()
  const { hasTherapist, hasCoach, isLoading } = useCareTeam()
  const { t } = useTranslation()
  const isCoachingAvailable = useIsCoachingAvailable()

  // With no care team yet, the tab is purely a coaching upsell — so it's hidden
  // outright for users who can't buy a coach. Anyone already working with a
  // therapist or coach keeps it regardless of language.
  const showCareTab = hasTherapist || hasCoach || isCoachingAvailable

  if (
    userIsTypingMessageToCoach ||
    location.pathname === "/subscription-cancel" ||
    location.pathname === "/checkout" ||
    location.pathname === "/referral-landing" ||
    isLoading
  )
    return <></>

  return (
    <div
      style={{
        background: JoonUIColor.background.primaryNeutral,
        position: "fixed",
        bottom: 0,
        width: "100vw",
        padding: `0 ${SPACING.space4}`,
        height: "70px",
        borderTop: `1px solid ${JoonUIColor.border.default}`,
        zIndex: "500",
        display: "flex",
        justifyContent: "space-around",
        boxShadow: "2px 0px 30px 0px rgba(36, 23, 185, 0.25)",
      }}
    >
      <MobileNavLink to="/me" name={t("NAV_ME")} Icon={MeIcon} />
      {showCareTab && (
        <MobileNavLink
          to="/care"
          name={hasTherapist ? t("NAV_CARE") : t("NAV_COACH")}
          Icon={CareIcon}
        />
      )}
      <MobileNavLink to="/quests" name={t("NAV_QUESTS")} Icon={QuestsIcon} />
      <MobileNavLink to="/rewards" name={t("NAV_REWARDS")} Icon={RewardsIcon} />
      <MobileNavLink to="/family" name={t("NAV_FAMILY")} Icon={FamilyIcon} />
    </div>
  )
}

export default MobileNav
